import { render, staticRenderFns } from "./ControlItem.vue?vue&type=template&id=edc86f20&"
import script from "./ControlItem.vue?vue&type=script&lang=js&"
export * from "./ControlItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports